<modal-container
  #modalDepotMetric
  [headerIconClass]="'far-building'"
  [headerTitle]="'product.set.quantity.levels'"
  [isLargeModal]="true"
  [isLoading]="isLoading"
  [hasBackdrop]="true"
  [ignoreBackdropClick]="false"
  [isModalInModal]="true"
>
  <ng-container class="modal-button-show" *ngIf="isLoading">
    <div class="spinner-border text-primary spinner-border-sm" role="status" *ngIf="isLoading">
      <span class="sr-only">{{ 'modal-product-depot-metric.loading' | translate }}</span>
    </div>
  </ng-container>

  <ng-container
    class="modal-button-show"
    *ngIf="!isLoading && this.productDepotMetric?.id && this.depot?.id === this.productDepotMetric?.depot?.id"
  >
    <!--    todo purchaseOrderItems count .. move this somewhere where it does make sense-->
    <div class="d-flex align-items-center">
      <div
        class="depot-quantity-container bg-white border-black"
        *ngIf="
          productDepotMetric.quantityPurchase > 0 &&
          !isLoading &&
          (productDepotMetric?.quantityMinimum !== null || productDepotMetric?.quantityOptimum !== null)
        "
      >
        <div class="warehouse-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="18" viewBox="0 0 22 18" fill="none">
            <path
              d="M21.45 12.9375H20.9V8.85586C20.9 8.18789 20.6353 7.5375 20.1747 7.06641L17.2906 4.1168C16.83 3.6457 16.1906 3.375 15.5409 3.375H14.3V1.96875C14.3 0.882422 13.4372 0 12.375 0H4.125C3.06281 0 2.2 0.882422 2.2 1.96875V3.375H0.275C0.12375 3.375 0 3.50156 0 3.65625V4.21875C0 4.37344 0.12375 4.5 0.275 4.5H8.525C8.67625 4.5 8.8 4.37344 8.8 4.21875V3.65625C8.8 3.50156 8.67625 3.375 8.525 3.375H3.85V1.96875C3.85 1.81406 3.97375 1.6875 4.125 1.6875H12.375C12.5263 1.6875 12.65 1.81406 12.65 1.96875V12.9375H8.34281C7.77219 11.932 6.72031 11.25 5.5 11.25C4.895 11.25 4.33813 11.4293 3.85 11.7176V10.125H2.2V14.625C2.2 16.4883 3.67812 18 5.5 18C7.32188 18 8.8 16.4883 8.8 14.625H13.2C13.2 16.4883 14.6781 18 16.5 18C18.3219 18 19.8 16.4883 19.8 14.625H21.45C21.7525 14.625 22 14.3719 22 14.0625V13.5C22 13.1906 21.7525 12.9375 21.45 12.9375ZM5.5 16.3125C4.58906 16.3125 3.85 15.5566 3.85 14.625C3.85 13.6934 4.58906 12.9375 5.5 12.9375C6.41094 12.9375 7.15 13.6934 7.15 14.625C7.15 15.5566 6.41094 16.3125 5.5 16.3125ZM14.3 5.0625H15.5409C15.7575 5.0625 15.9706 5.15391 16.1253 5.30859L18.6347 7.875H14.3V5.0625ZM16.5 16.3125C15.5891 16.3125 14.85 15.5566 14.85 14.625C14.85 13.6934 15.5891 12.9375 16.5 12.9375C17.4109 12.9375 18.15 13.6934 18.15 14.625C18.15 15.5566 17.4109 16.3125 16.5 16.3125ZM19.25 12.7652C18.6588 11.8547 17.6481 11.25 16.5 11.25C15.6509 11.25 14.8844 11.5875 14.3 12.1254V9.5625H19.25V12.7652ZM8.8 8.71875V8.15625C8.8 8.00156 8.67625 7.875 8.525 7.875H0.275C0.12375 7.875 0 8.00156 0 8.15625V8.71875C0 8.87344 0.12375 9 0.275 9H8.525C8.67625 9 8.8 8.87344 8.8 8.71875ZM9.625 6.75C9.77625 6.75 9.9 6.62344 9.9 6.46875V5.90625C9.9 5.75156 9.77625 5.625 9.625 5.625H1.375C1.22375 5.625 1.1 5.75156 1.1 5.90625V6.46875C1.1 6.62344 1.22375 6.75 1.375 6.75H9.625Z"
              fill="#231F20"
            />
          </svg>
        </div>

        <div class="d-flex align-items-center">
          <div class="font-weight-bold">
            {{ productDepotMetric.quantityPurchase * getPackPiecesIfInPack() + ' ' + ('piece' | translate) }}
          </div>
        </div>
      </div>

      <button
        *ngIf="
          !isLoading && (productDepotMetric?.quantityMinimum !== null || productDepotMetric?.quantityOptimum !== null)
        "
        type="button"
        class="btn text-nowrap"
        [disabled]="readonly"
        (click)="showChildModal()"
      >
        <div class="depot-metric-icons">
          <div
            *ngIf="productDepotMetric?.quantityMinimum !== null"
            class="flex-gap-5 align-items-center blue font-weight-bold"
            [title]="'product.quantity.levels.minimal' | translate"
          >
            {{ 'min' + '&nbsp;' + (productDepotMetric?.quantityMinimum ?? 0) + ' ' + ('piece' | translate) }}
          </div>
          <div
            *ngIf="productDepotMetric?.quantityOptimum !== null"
            class="flex-gap-5 align-items-center font-weight-bold"
            [title]="'product.quantity.levels.optimal' | translate"
          >
            {{ 'opt' + '&nbsp;' + (productDepotMetric?.quantityOptimum ?? 0) + ' ' + ('piece' | translate) }}
          </div>
        </div>
      </button>
    </div>

    <div class="spinner-border text-primary spinner-border-sm" role="status" *ngIf="isLoading">
      <span class="sr-only">{{ 'modal-product-depot-metric.loading' | translate }}</span>
    </div>
  </ng-container>

  <ng-container
    class="modal-button-show"
    *ngIf="
      !isLoading &&
      (!productDepotMetric?.id ||
        (productDepotMetric?.quantityMinimum === null && productDepotMetric?.quantityOptimum === null))
    "
  >
    <div class="d-flex align-items-center">
      <div
        class="depot-quantity-container bg-white border-black"
        *ngIf="productDepotMetric.quantityPurchase > 0 && !isLoading"
      >
        <div class="warehouse-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="18" viewBox="0 0 22 18" fill="none">
            <path
              d="M21.45 12.9375H20.9V8.85586C20.9 8.18789 20.6353 7.5375 20.1747 7.06641L17.2906 4.1168C16.83 3.6457 16.1906 3.375 15.5409 3.375H14.3V1.96875C14.3 0.882422 13.4372 0 12.375 0H4.125C3.06281 0 2.2 0.882422 2.2 1.96875V3.375H0.275C0.12375 3.375 0 3.50156 0 3.65625V4.21875C0 4.37344 0.12375 4.5 0.275 4.5H8.525C8.67625 4.5 8.8 4.37344 8.8 4.21875V3.65625C8.8 3.50156 8.67625 3.375 8.525 3.375H3.85V1.96875C3.85 1.81406 3.97375 1.6875 4.125 1.6875H12.375C12.5263 1.6875 12.65 1.81406 12.65 1.96875V12.9375H8.34281C7.77219 11.932 6.72031 11.25 5.5 11.25C4.895 11.25 4.33813 11.4293 3.85 11.7176V10.125H2.2V14.625C2.2 16.4883 3.67812 18 5.5 18C7.32188 18 8.8 16.4883 8.8 14.625H13.2C13.2 16.4883 14.6781 18 16.5 18C18.3219 18 19.8 16.4883 19.8 14.625H21.45C21.7525 14.625 22 14.3719 22 14.0625V13.5C22 13.1906 21.7525 12.9375 21.45 12.9375ZM5.5 16.3125C4.58906 16.3125 3.85 15.5566 3.85 14.625C3.85 13.6934 4.58906 12.9375 5.5 12.9375C6.41094 12.9375 7.15 13.6934 7.15 14.625C7.15 15.5566 6.41094 16.3125 5.5 16.3125ZM14.3 5.0625H15.5409C15.7575 5.0625 15.9706 5.15391 16.1253 5.30859L18.6347 7.875H14.3V5.0625ZM16.5 16.3125C15.5891 16.3125 14.85 15.5566 14.85 14.625C14.85 13.6934 15.5891 12.9375 16.5 12.9375C17.4109 12.9375 18.15 13.6934 18.15 14.625C18.15 15.5566 17.4109 16.3125 16.5 16.3125ZM19.25 12.7652C18.6588 11.8547 17.6481 11.25 16.5 11.25C15.6509 11.25 14.8844 11.5875 14.3 12.1254V9.5625H19.25V12.7652ZM8.8 8.71875V8.15625C8.8 8.00156 8.67625 7.875 8.525 7.875H0.275C0.12375 7.875 0 8.00156 0 8.15625V8.71875C0 8.87344 0.12375 9 0.275 9H8.525C8.67625 9 8.8 8.87344 8.8 8.71875ZM9.625 6.75C9.77625 6.75 9.9 6.62344 9.9 6.46875V5.90625C9.9 5.75156 9.77625 5.625 9.625 5.625H1.375C1.22375 5.625 1.1 5.75156 1.1 5.90625V6.46875C1.1 6.62344 1.22375 6.75 1.375 6.75H9.625Z"
              fill="#231F20"
            />
          </svg>
        </div>

        <div class="d-flex align-items-center">
          <div class="font-weight-bold">
            {{ productDepotMetric.quantityPurchase * getPackPiecesIfInPack() + ' ' + ('piece' | translate) }}
          </div>
        </div>
      </div>
      <btn
        *ngIf="!isOnProductsPage && hasRoleMetricsCreate"
        class="btn text-nowrap"
        [classes]="['btn-first', 'mr-2']"
        [label]="'product.set.quantity.levels'"
        [title]="'product.set.quantity.levels' | translate"
        (click)="showChildModal()"
      ></btn>
    </div>
    <div *ngIf="!isOnProductsPage && !hasRoleMetricsCreate">
      <div class="grey-text">{{ 'no.metrics.set' | translate }}&nbsp;</div>
    </div>
    <div *ngIf="isOnProductsPage" class="d-flex align-items-baseline">
      <div class="grey-text">{{ 'no.metrics.set' | translate }}&nbsp;</div>
      <a
        *ngIf="hasRoleMetricsCreate"
        class="link-red"
        (click)="showChildModal()"
        (keyup)="showChildModal()"
        tabindex="-1"
        >{{ 'product.set.quantity.levels' | translate }}</a
      >
    </div>
  </ng-container>

  <ng-container class="modal-body-content">
    <div class="card" *ngIf="productDepotMetric?.product?.id || isCreating">
      <div class="table-responsive">
        <table class="table mb-0">
          <tbody>
            <tr>
              <td class="border-0 no-hover p-0">
                <div class="flex-gap-10 align-items-center">
                  <product-image [product]="product"></product-image>
                  <div class="d-flex flex-column align-items-start">
                    <a class="link-bold" [routerLink]="['/product', product]">{{ product.name }}</a>
                    <div class="product-details flex-gap-5">
                      <div *ngIf="product.code">{{ 'product.code' | translate }}: {{ product.code }}</div>
                      <div *ngIf="product.ean">{{ 'product.ean' | translate }}: {{ product.ean }}</div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="card">
      <div class="flex-justify-content-center" *ngIf="depot">
        <div class="flex-direction-column">
          <div class="text-align-center">
            {{ depot.depot?.name }}
          </div>
          <div class="availability-icons" style="width: 200px">
            <div class="flex-gap-5 align-items-center">
              <i class="far fa-warehouse-alt"></i>
              {{ depot.sumAll }}
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="productDepotMetric && hasRoleMetricsUpdate" class="d-flex justify-content-center gap-5">
        <div class="quantity-inputs-container gap-2">
          <div class="flex-gap-1">
            <form-row-number-with-controls
              [label]="'product.quantity.levels.minimal'"
              [model]="productDepotMetric.quantityMinimum"
              (modelChange)="quantityMinimumChanged($event)"
              [requiredCssClass]="
                submitted &&
                (Number(productDepotMetric.quantityMinimum) < 0 || this.productDepotMetric.quantityMinimum % 1 != 0)
              "
              [minValue]="0"
              [justIntegers]="true"
              [maxWidthPx]="130"
              [noMarginBottom]="true"
            ></form-row-number-with-controls>
            <div class="padding-top-1-5">
              {{ 'piece' | translate }}
            </div>
          </div>
          <div *ngIf="isProductCountByPiece" class="flex-gap-1">
            <form-row-number-with-controls
              [label]="'product.quantity.levels.minimal'"
              [model]="quantityMinimumForPack"
              (modelChange)="quantityMinimumForPackChanged($event)"
              [minValue]="0"
              [justIntegers]="true"
              [maxWidthPx]="130"
              [noMarginBottom]="true"
            ></form-row-number-with-controls>
            <div class="padding-top-1-5">
              {{ 'pack' | translate }}
            </div>
          </div>
        </div>
        <div class="quantity-inputs-container gap-2">
          <div class="flex-gap-1">
            <form-row-number-with-controls
              [label]="'product.quantity.levels.optimal'"
              [model]="productDepotMetric.quantityOptimum"
              (modelChange)="quantityOptimumChanged($event)"
              [requiredCssClass]="
                submitted &&
                (Number(productDepotMetric.quantityOptimum) < 0 || this.productDepotMetric.quantityOptimum % 1 != 0)
              "
              [minValue]="0"
              [justIntegers]="true"
              [maxWidthPx]="130"
              [noMarginBottom]="true"
            ></form-row-number-with-controls>
            <div class="padding-top-1-5">
              {{ 'piece' | translate }}
            </div>
          </div>
          <div *ngIf="isProductCountByPiece" class="flex-gap-1">
            <form-row-number-with-controls
              [label]="'product.quantity.levels.optimal'"
              [model]="quantityOptimumForPack"
              (modelChange)="quantityOptimumForPackChanged($event)"
              [minValue]="0"
              [justIntegers]="true"
              [maxWidthPx]="130"
              [noMarginBottom]="true"
            ></form-row-number-with-controls>
            <div class="padding-top-1-5">
              {{ 'pack' | translate }}
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="productDepotMetric && !hasRoleMetricsUpdate" class="quantity-inputs-container">
        <div class="depot-metric-icons">
          <div
            class="flex-gap-5 align-items-center blue font-weight-bold"
            [title]="'product.quantity.levels.minimal' | translate"
          >
            {{
              'min' +
                '&nbsp;' +
                (productDepotMetric?.quantityMinimum ? productDepotMetric.quantityMinimum : 0) +
                ' ' +
                ('piece' | translate)
            }}
          </div>
          <div
            class="flex-gap-5 align-items-center font-weight-bold"
            [title]="'pro duct.quantity.levels.optimal' | translate"
          >
            {{
              'opt' +
                '&nbsp;' +
                (productDepotMetric?.quantityOptimum ? productDepotMetric.quantityOptimum : 0) +
                ' ' +
                ('piece' | translate)
            }}
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container class="modal-footer-content">
    <btn
      *ngIf="productDepotMetric?.id > 0"
      [label]="'delete'"
      [title]="'delete' | translate"
      [icon]="'far-trash-alt'"
      [classes]="['btn-first-red', 'btn-sm', 'float-right']"
      (onEvent)="deleteProductDepotMetric()"
    ></btn>
    <btn
      [label]="'save'"
      [title]="'save' | translate"
      [icon]="'fa-check far mr-2'"
      [classes]="['btn-first']"
      (onEvent)="productDepotMetric?.id ? updateProductDepotMetric() : createProductDepotMetric()"
    ></btn>
  </ng-container>
</modal-container>
